import { customDocumentValueProperties } from './documentValueCustom.schema';

export default {
  type: 'object',
  properties: {
    id: { type: 'number' },
    code: { title: 'Nazwa', type: 'string', fieldRequired: true },
    value: {
      type: 'object',
      properties: {
        number: {
          disabled: '!$root.code || $root.code.indexOf("NUMBER") < 0 || $root.code.indexOf("_TEXT") >= 0',
          type: 'string',
          calc: { func: 'this.numbers[this.numbers.length - 1].number', when: '!!this.numbers.length' }
        },
        numbers: {
          disabled: '!$root.code || $root.code.indexOf("NUMBER") < 0 || $root.code.indexOf("_TEXT") >= 0',
          title: 'Wartości',
          type: 'array',
          items: {
            type: 'object',
            properties: {
              number: {
                title: ['if (this.added) {', 'return "Nowa wartość";', '}', 'return "Wartość";'],
                type: 'string',
                fieldRequired: true
              },
              added: { type: 'boolean', computed: true }
            }
          }
        },
        date: {
          disabled: '!$root.code || $root.code.indexOf("DATE") < 0',
          title: 'Wartość',
          type: 'string',
          fieldRequired: false,
          format: 'date',
          calc: {
            func: [
              'const timestamps = this.dates.map(function (date) { return new Date(date.date).getTime();}).map(function (val) { return val > 0 ? val : 0;});',
              'const index = timestamps.indexOf(Math.max.apply(Math, timestamps));',
              'return this.dates[index] && this.dates[index].date'
            ],
            when: '!!this.dates.length'
          }
        },
        dates: {
          disabled: '!$root.code || $root.code.indexOf("DATE") < 0',
          title: 'Wartości',
          type: 'array',
          items: {
            type: 'object',
            properties: {
              date: {
                title: ['if (this.added) {', 'return "Nowa wartość";', '}', 'return "Wartość";'],
                type: 'string',
                format: 'date',
                fieldRequired: true
              },
              added: {
                type: 'boolean',
                computed: true
              }
            }
          }
        },
        text: {
          disabled: '!$root.code || $root.code.indexOf("_TEXT") < 0',
          fieldRequired: true,
          title: 'Wartość',
          type: 'string'
        },
        bool: {
          disabled: '!$root.code || !$root.code.startsWith("IS_")',
          title: 'Wartość',
          type: 'boolean'
        },
        // Pola dla niestandardowych edytorów wartości dokumentu (np. OW004_ART174_DEDUCTIONS).
        ...customDocumentValueProperties
      }
    },
    documentId: {
      title: 'Identyfikator dokumentu',
      type: 'number',
      fieldRequired: true
    }
  }
};
